import React from 'react';
import { motion } from 'framer-motion';
const tomos = [{
  image: 'https://cdn.magicpatterns.com/uploads/94QuG58JJQFBGcbTm8MGGc/tomo_1.png',
  title: 'Tomo 1',
  subtitle: 'Arranque con control',
  desc: 'Claridad y control (Semana 1)',
  bg: 'bg-orange-50 border-orange-200'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/sCGbfxZ3Wgk1RcUhVKyMVV/tomo_2.png',
  title: 'Tomo 2',
  subtitle: 'Sostener sin obsesión',
  desc: '12 semanas de método real',
  bg: 'bg-sky-50 border-sky-200'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/jxJViyvNaDxr1HLvnYkFiE/tomo_3.png',
  title: 'Tomo 3',
  subtitle: 'Dominar el mes',
  desc: 'Pagos, imprevistos y plan B',
  bg: 'bg-green-50 border-green-200'
}];
export function ProductOverview() {
  return <section className="py-16 bg-[#8EB4F2A4]" data-id="element-207">
      <div className="container mx-auto px-4" data-id="element-208">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-209">
          <div className="inline-block px-4 py-1.5 mb-4 text-xs font-bold tracking-widest text-blue-600 bg-blue-50 rounded-full border border-blue-200 uppercase" data-id="element-210">
            🏆 TU SOLUCIÓN DIGITAL™
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-black uppercase tracking-tight mb-3" data-id="element-211">
            Sistema 12 Semanas
          </h2>
          <p className="text-sm text-[#042C64]" data-id="element-212">
            3 Tomos — 12 semanas — Todo guiado. Claridad → Método semanal →
            Ajustes que se sostienen.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-4 md:gap-6 max-w-3xl mx-auto" data-id="element-213">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`rounded-2xl border-2 p-3 md:p-4 flex flex-col items-center text-center ${tomo.bg}`} data-id="element-214">
              <img src={tomo.image} alt={tomo.title} className="w-full h-auto rounded-lg mb-3 shadow-sm" data-id="element-215" />
              <h3 className="text-sm md:text-base font-black text-black uppercase" data-id="element-216">
                {tomo.title}
              </h3>
              <p className="text-xs md:text-sm font-bold text-slate-700" data-id="element-217">
                {tomo.subtitle}
              </p>
              <p className="text-xs text-slate-500 mt-1 hidden md:block" data-id="element-218">
                {tomo.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}